import script from "./UserDynamicForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDynamicForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__